import { render, staticRenderFns } from "./zuiminlist.vue?vue&type=template&id=a6f213a8&scoped=true&"
import script from "./zuiminlist.vue?vue&type=script&lang=js&"
export * from "./zuiminlist.vue?vue&type=script&lang=js&"
import style0 from "./zuiminlist.vue?vue&type=style&index=0&id=a6f213a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f213a8",
  null
  
)

export default component.exports